import { Row } from "./row";

export interface TagJSON {
  id: number;
  created: Date;
  tag: string;
  entry_id: number;
  user_id: number;
  hidden: boolean;
}

export function slugify(tag: string): string {
  return tag.toLowerCase().replace(/%/g, "-percent-");
}

export function deslugify(slug: string): string {
  // Gets around the fact that react-router-v5 can't handle % characters in the URL
  // https://github.com/remix-run/react-router/issues/11179
  return slug.replace(/-percent-/g, "%");
}

export class Tag extends Row<TagJSON> implements TagJSON {
  declare id: number;
  declare created: Date;
  declare tag: string;
  declare tag_slug: string;
  declare entry_id: number;
  declare user_id: number;
  declare hidden: boolean;

  constructor(props: TagJSON) {
    super(props);

    this.created = new Date(this.created);
    this.tag_slug = slugify(this.tag);
  }
}

export function IsTag(x: any): x is TagJSON {
  return x.created && x.tag && x.entry_id && x.user_id;
}
